import React from 'react';

const DisplayParam = props => {
  return (
    props.param ? <p>{props.param}</p> : null
  );
};

export default DisplayParam;
